// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_ketogo_container__2QCzT","selected":"CheckBox_ketogo_selected__33o2z","customSizeSpan":"CheckBox_ketogo_customSizeSpan__3pNi-"};